import { useMemo, useRef, useState } from 'react';
import { TextArea, TextBox } from '../../shared/controls/form';
import { useSelector } from 'react-redux';
import { getProductDropdown } from '../../redux/selector';
import SelectBox from '../../shared/controls/form/selectBox';
import { AgGridReact } from 'ag-grid-react';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const ChildSalesOrder = ({
  rowData,
  handleChangeForm,
  handleAddRow,
  formData,
  handleChange,
  selectedOptions,
  handleDeleteRow,
  handleAddPriceSheetToItems, errormsg
}) => {
  const gridRef = useRef();
  const [selectedOption, setSelectedOption] = useState({});
  const productOptions = useSelector(getProductDropdown);
  const [priceSheetByProductId, setPriceSheetByProductId] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const location = useLocation();

  const handleOpen = (productId) => {
    if (!productId) {
      toast.error('Product is not selected');
      return;
    }

    setIsOpen(true);
    fetchPriceSheetListByProductId(productId);
  };

  const fetchPriceSheetListByProductId = async (productId) => {
    try {
      const response = await apiServices.getPriceSheetsByProductId(productId); // Adjust this API name if needed
      if (response.status === 200) {
        setPriceSheetByProductId(response?.data?.productPriceSheetAssociations);
      } else {
        console.error('Failed to fetch price sheets:', response);
      }
    } catch (error) {
      console.error('Error while fetching price sheets by account:', error);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const allColumnDefs = [
    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,

      cellRenderer: (params) => {
        return (
          <img
            onClick={() => handleDeleteRow(params.node.rowIndex, params.data.id)}
            src="/assets/images/trash.png"
            className="action_dlt"
            alt="Delete Account"
            title="Delete Account"
          ></img>
        );
      },
      suppressMovable: true,
      sortable: false,
      filter: false,
      editable: false,
    },
    {
      headerName: 'S.No.',
      valueGetter: (params) => params.node.rowIndex + 1,
      sortable: false,
      filter: false,
      maxWidth: 70,
      resizable: false,
      editable: false,
    },
    {
      headerName: 'Product Name',
      field: 'productId',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: productOptions,
      },

      cellEditorParams: {
        values: ['Select Product', ...productOptions.map((p) => p.name)],

      },
      valueFormatter: (params) => {
        if (!params.value || params.value === 'Select Product') {
          return 'Select Product';
        }
        const product = productOptions.find(
          (p) => p.name === params.value || p.id === params.value
        );
        return product ? product.name : '';
      },

      valueParser: (params) => {
        return params.newValue;
      },
      cellClassRules: {
        'cell-error': (params) => !params.value || params.value === 'Select Product',
      },
    },
    {
      headerName: 'Description',
      field: 'description',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Quantity',
      field: 'quantity',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agNumberCellEditor',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agNumberCellEditor',
    },
    {
      headerName: ' ',
      field: 'icon',
      sortable: false,
      filter: false,
      maxWidth: 50,
      editable: false,
      cellRenderer: (props) => {
        const selectedProductId = props.data.productId; // 👈 Access the selected productId here

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
            onClick={(e) => e.stopPropagation()} // Prevent cell from going to edit mode
          >
            <i
              className="bi bi-tag-fill"
              style={{ color: '#4C70BE', cursor: 'pointer' }}
              title="Click to trigger action"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpen(selectedProductId); // 👈 Pass it to your function
              }}
            ></i>
          </div>
        );
      },
    },
    {
      headerName: 'Amount ($)',
      field: 'amount',
      sortable: true,
      filter: false,
      editable: false,
      cellEditor: 'agNumberCellEditor',
    },
    {
      headerName: 'Discount Percent (%)',
      field: 'discountPercent',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}%` : ''),
    },
    {
      headerName: 'Discount Amount ($)',
      field: 'discountAmount',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}` : ''),
    },
    {
      headerName: 'Tax Percent (%)',
      field: 'taxPercent',
      sortable: true,
      filter: false,
      width: 150,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}%` : ''),
    },
    {
      headerName: 'Tax Amount ($)',
      field: 'taxAmount',
      sortable: true,
      filter: false,
      editable: true,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}` : ''),
    },
    {
      headerName: 'Total ($)',
      field: 'lineTotal',
      sortable: true,
      filter: false,
      editable: false,
      cellEditor: 'agNumberCellEditor',
    },
  ];

  const isViewMode = location.pathname.includes('view');

  const columnDefs = allColumnDefs
    // hide Actions + Icon in view mode
    .filter((col) => !(isViewMode && (col.field === 'actions' || col.field === 'icon')))
    // lock everything as non-editable in view mode
    .map((col) => ({
      ...col,
      editable:
        isViewMode
          ? false
          : col.editable, // keep original editable in edit mode
    }));

  const priceSheetColumnDefs = [
    {
      headerName: 'Name',
      field: 'priceSheetName',
      width: 150,
      filter: 'agSetColumnFilter',
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      headerName: 'Currency',
      field: 'currencyPrice',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      width: 150,
      filter: 'agSetColumnFilter',
    },
  ];

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
  };

  const handleSubmit = () => {
    // const selectedListPrice = selectedRowsPopup.map((row) => row.listPrice);

    handleAddPriceSheetToItems(selectedRowsPopup);
    setSelectedRowsPopup([]);
    handleClose();
  };

  return (
    <div className="block-row Cnt_view">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox" >
          <div className="addlead-header pd_card">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/quoteAi/images/quotesItemInfo.svg" alt="" />
              Items<span className="required-star">*</span>
            </label>
            <span className="error-message">{errormsg?.['saleOrderDetails[0].productId']}</span>
          </div>
          <div className="quoteContent">
            <>
              <div className="row">
                <div
                  className=" col-12 col-sm-12 col-md-9">
                  <div className="ag-theme-balham tbl_height" style={{

                    height: '322px',
                  }}>
                    <AgGridReact

                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={columnDefs}
                      defaultColDef={{ resizable: true, editable: true, minWidth: 100, }}
                      stopEditingWhenCellsLoseFocus={true}
                      singleClickEdit={true}
                      domLayout="normal"
                      onCellValueChanged={(params) => {
                        handleChangeForm(params.data, params.node.rowIndex, 'SalesOrder');
                        if (params.colDef.field === 'productId') {
                          const selectedProduct = productOptions.find(
                            (p) => p.name === params.newValue
                          );

                          if (selectedProduct) {
                            handleChange(
                              {
                                value: selectedProduct.id,
                                label: selectedProduct.name,
                              },
                              'productId',
                              params.node.rowIndex
                            );
                          }
                        } else {
                          handleChange(params.colDef.field, params.newValue);
                        }
                      }}
                    />


                  </div>
                   {formData?.type != 'view' && (
                      <button
                        type="button"
                        className="btn btn-primary btn-square"
                        onClick={handleAddRow}
                        title="Add Row"
                      >
                        <i className="bi bi-plus-lg"></i>
                      </button>
                    )}
                </div>


                <div className="col-12 col-sm-12 col-md-3">
                  <div className="orderSummary">
                    <div className="summaryDes textRight">
                      <div className="summaryHeader">
                        <h2>Order Summary</h2>
                      </div>
                      <div className="summaryRow">
                        <TextBox
                          // isRequired={true}
                          label={'Sub Total'}
                          name={'subTotal'}
                          placeholder={formData?.type === 'view' ? '$ 0.00' : '0'}
                          value={`$ ${formData?.subTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.subTotal}
                          disabled={formData?.type === 'view'}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Discount'}
                          name={'discountTotal'}
                          placeholder={formData?.type === 'view' ? '$ 0.00' : '0'}
                          value={`$ ${formData?.discountTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.discount}
                          disabled={formData?.type === 'view'}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Tax'}
                          name={'taxTotal'}
                          placeholder={formData?.type === 'view' ? '$ 0.00' : '0'}
                          value={`$ ${formData?.taxTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.taxTotal}
                          disabled={formData?.type === 'view'}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Adjustment'}
                          name={'adjustment'}
                          placeholder={formData?.type === 'view' ? '$ 0.00' : '0'}
                          value={`$ ${formData?.adjustment?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.noOfEmployees}
                          disabled={formData?.type === 'view'}
                        />
                      </div>

                      <div className="summaryRow totalRow">
                        <TextBox
                          label={'Grand Total'}
                          name={'grandTotal'}
                          placeholder={formData?.type === 'view' ? '$ 0.00' : '0'}
                          value={`$ ${formData?.grandTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.grandTotal}
                          disabled={formData?.type === 'view'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
        {isOpen && (
          <div id="genricPopup">
            <div className="popup-backdrop">
              <div className="popup fullWidthPopup">
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">Choose PriceSheet</h4>
                  <button className="custom-btn-close" onClick={handleClose}></button>
                </div>
                {/* Popup Body */}
                <div className="popup-body">
                  <div className="popupbody_header">
                    <div className="hd_leftview">
                      <div className="heading_item" id="contct_search">
                        {/* <div className="search-container">
                                              <input
                                                type="text"
                                                id="filter-text-box"
                                                className={`form-control${searchText ? " focused" : ""}`}
                                                placeholder="Search..."
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                              />

                                              {searchText && (
                                                <span className="clear-btn" onClick={clearSearch}>
                                                  &times;
                                                </span>
                                              )}
                                              <button className="contactsearch" type="button" onClick={() => onSearch(searchText)}
                                                onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <circle cx="11" cy="11" r="8"></circle>
                                                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                </svg>
                                              </button>
                                            </div> */}
                      </div>
                      {/* <div className="flx_heding view_fnt" id="action_dropdown">

                                          <>
                                            <label
                                              htmlFor="memberStatusId"
                                              style={{ width: "100px" }}
                                            >
                                              Member Status:
                                            </label>
                                            <Select
                                              id="memberStatus"
                                              value={selectedOptions.memberStatus}
                                              placeholder={formData.memberStatusId}
                                              onChange={(selectedOption) =>
                                                handleChange(selectedOption, "memberStatusId")
                                              }
                                              options={memberStatus?.map((data) => ({
                                                value: data.id,
                                                label: data.displayName,
                                              }))}
                                              styles={{
                                                container: (base) => ({
                                                  ...base,
                                                  width: "200px",
                                                  minHeight: "30px"
                                                }),
                                                menu: (base) => ({
                                                  ...base,
                                                  zIndex: "9999",
                                                  height: "200px",
                                                  overflow: "auto",
                                                  color: "#000",
                                                }),
                                                control: (base) => ({
                                                  ...base,
                                                  borderRadius: "6px",
                                                }),
                                              }}
                                            />
                                          </>
                                        </div> */}
                    </div>
                    <div className="hd_rightview" id="update_campaign">
                      <div className="flx_heding view_fnt">
                        <label>
                          Total Records: <span>{priceSheetByProductId?.length}</span>
                        </label>
                      </div>

                      <span className="separator"></span>
                      <div className="flx_heding">
                        <button
                          className="add-btn"
                          type="button"
                          onClick={() => handleSubmit(formData)}
                          disabled={!selectedRowsPopup.length > 0 || loading}
                        >
                          {selectedRowsPopup.length > 0 && loading && (
                            <>
                              {' '}
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></div>
                            </>
                          )}
                          {selectedRowsPopup.length > 0 && loading
                            ? 'Loading...'
                            : 'Add to Quote Items'}
                        </button>
                      </div>

                      {/* Popup 2 Overlay */}
                    </div>
                  </div>
                  <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                    <div
                      className="ag-theme-balham tbl_height"
                      style={{
                        height: 'calc(100vh - 320px)',
                        width: '100%',
                      }}
                    >
                      <AgGridReact
                        rowData={priceSheetByProductId}
                        columnDefs={priceSheetColumnDefs}
                        suppressRowClickSelection={true}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        // sideBar={sideBar}
                        rowSelection="single"
                        onSelectionChanged={onSelectionChangedPopup}
                        ref={gridRef}
                      // statusBar={statusBar}
                      // onGridReady={onGridReady}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChildSalesOrder;
